import request from "@utils/request";

/**
 * 答题相关
 * @param data object 用户账号密码
 */
export  function queryResultByDate(data) {
    return request.get("/test/api/result/queryResultByDate", data, {login: false});
}

export  function getlistByParam(data) {
    return request.get("/test/api/result/getlistByParam", data, {login: false});
}
